<template>
  <div class="p-4 text-center space-y-6 bg-element">
    <slot />
  </div>
</template>
